import { Navigate, useLocation } from '@solidjs/router';
import { Form, Input, TextField, Label, Button, Errors } from '@troon/ui';
import { useTrackEvent } from '@troon/analytics';
import { For, Match, Show, Switch } from 'solid-js';
import { unwrap } from 'solid-js/store';
import { clientAction } from '@troon/api-client';
import { useAuthStore } from '../flow';
import type { AuthCompleteCredentials } from '../auth';

type Props = {
	onComplete?: (credentials: AuthCompleteCredentials) => void;
};

export function PostalCode(props: Props) {
	const [store] = useAuthStore();
	const location = useLocation();
	const trackEvent = useTrackEvent();

	const action = clientAction(
		'post',
		'/v0/auth/signup',
		{},
		{
			revalidate: undefined,
			onSuccess: async (res) => {
				trackEvent('signup', {
					$set: { email: res.user.email, fullName: `${(res.user.firstName, res.user.lastName)}` },
					email: res.user.email,
				});
				props.onComplete?.({
					accessToken: res.accessToken,
					refreshToken: res.refreshToken,
					user: res.user,
				});
			},
		},
	);

	return (
		<Switch>
			<Match when={!store.data.email || !store.data.password || !store.data.firstName || !store.data.lastName}>
				<Navigate href={`/auth${location.search}`} />
			</Match>

			<Match when={true}>
				<Form action={action} method="post" suppressRequired>
					<For each={Object.entries(unwrap(store.data))}>
						{([key, value]) => (
							<Show when={value}>
								<input type="hidden" name={key} value={value} />
							</Show>
						)}
					</For>

					<TextField name="zipcode">
						<Label>Postal code</Label>
						<Input
							inputMode="numeric"
							autofocus
							onInput={() => {
								trackEvent('signupEnteredZipcode', { email: store.data.email }, { noDuplicates: true });
							}}
						/>
					</TextField>

					<Errors />

					<Button type="submit">Continue</Button>
				</Form>
			</Match>
		</Switch>
	);
}
